export default __webpack_public_path__ + "a4c9003b405eb093c3f82e7b00cdb605.svg";